export const FORM_CONTEXT = 'form_context';
export const EXTERNAL_BILLING_INFO = 'external_payment_billing_info';
export const EXTERNAL_PAYMENT_ID = 'external_payment_id';
